export default __webpack_public_path__ + "static/media/splashScreen.39718e90.webm";